<script>
export default {
    props: {
        placeholder: {
            type: String,
            required: true
        },
        classes: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        styles: {
            type: String
        },
        value: {
            type: String
        },
        id: {
            type: String
        },
        name: {
            type: String
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        searchInputTrigger: {
            type: Function,
            required: true
        }

    },
    methods: {
        change(val) {
            this.$emit('input', val)
        },
        emptyInput() {
            this.change('')
        }
    },
    computed: {
        searchValueRequired() {
            let data = this.value == null ? false : (this.value.trim() == '' ? false : true)
            data = this.isRequired ? data : true
            data = data ? this.searchInputTrigger : this.emptyInput
            return data
        } 
    }
};
</script>

<template>
    <input :style="styles" :type="type" :class="classes" :id="id" :name="name" :placeholder="placeholder" :required="isRequired" :value="value" @input="change($event.target.value)" @keydown.enter="searchValueRequired"/>
</template>
